const TOKEN_HEADER_NAME = 'X-FOM-Token'

export class FomToken {
  token: string | null

  constructor(response: Response) {
    this.token = response?.headers.get(TOKEN_HEADER_NAME)
  }

  appendToObject(headers: Record<string, string>): Record<string, string> {
    if (!this.token || !headers || typeof headers !== 'object') {
      return headers
    }

    headers[TOKEN_HEADER_NAME] = this.token

    return headers
  }
}
